import { ThunkResult } from '../../../stores/types';
import formatErrorResponseV2 from '../../../utilities/format-error-response-v2';
import ActionTypes from '../constants/action-types';

export default function fetchOrderSettings(
  organization: string,
  orderNumber: string,
): ThunkResult<Promise<io.flow.internal.v0.models.OrderSettings | undefined>> {
  return (dispatch, getState, extra):
  Promise<io.flow.internal.v0.models.OrderSettings | undefined> => {
    dispatch({
      type: ActionTypes.FETCH_ORDER_SETTINGS_REQUEST,
    });

    return extra.apiInternal(getState()).orderSettings
      .getByNumber({
        organization,
        number: orderNumber,
      }).then((response) => {
        if (response.ok) {
          dispatch({
            type: ActionTypes.FETCH_ORDER_SETTINGS_SUCCESS,
            payload: response.body,
          });
          return response.body;
        }
        if (response.status === 404) {
          // Orders without recorded settings (e.g. non-Shopify) 404 by design; not an error.
          dispatch({
            type: ActionTypes.FETCH_ORDER_SETTINGS_NOT_FOUND,
          });
          return undefined;
        }
        dispatch({
          type: ActionTypes.FETCH_ORDER_SETTINGS_FAILURE,
          payload: formatErrorResponseV2(response),
          error: true,
        });
        return undefined;
      }).catch((e: unknown) => {
        console.error('[fetchOrderSettings] Malformed API response:', e);
        dispatch({
          type: ActionTypes.FETCH_ORDER_SETTINGS_FAILURE,
          payload: {
            messages: [{
              message: e instanceof Error ? e.message : 'Unknown error',
            }],
          },
          error: true,
        });
        return undefined;
      });
  };
}
